import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import RetargetingsGridLayout from './containers/Grid';

export default function RetargetingLayout() {
  return <Router>
    <PrivateRoute path="/path/retargeting" component={RetargetingsGridLayout} />
  </Router>
}
